module.exports = __webpack_public_path__ + "media/images/konintodoke/donwload-icon-e21a5241599ee5acee7665cb9822b5a0.svg";